import React from 'react';
import { connect } from 'react-redux';
import * as MaterialUI from 'material-ui';
import FontAwesome from 'react-fontawesome';
import { push } from 'react-router-redux';

@connect()
export default class extends React.Component {
  constructor(props){
    super(props);
  }
  add = (id,name,lastname) => this.props.dispatch(push(`/dashboard/roles/add/${id}/${name}/${lastname}`))
  render(){
    const { abonado } = this.props;
    return <div>
      <MaterialUI.ListItem
        onTouchTap={this.add.bind(this, abonado.get('id'),abonado.get('nombre'), abonado.get('apellido'))}
        primaryText={abonado.get('nombre')+' '+abonado.get('apellido')}
        rightIconButton={abonado.get('registerByApp') ? <FontAwesome name="mobile" className="iconBig" /> : null}
      />
      <MaterialUI.Divider/>
    </div>;
  }
}



// WEBPACK FOOTER //
// src/modules/roles/components/itemList.js